<template>
  <div>
    <div class="content-area__heading pr-4 border-0">
      <h3 style="margin-bottom: 20px">Configuración</h3>
    </div>
    <form data-vv-scope="form" ref="form">
      <vx-card style="margin-top: 20px">
        <vs-row>
          <vs-col vs-w="6">
            <input type="hidden" v-model="user_id" />
            <vs-input
              label="Nombre"
              placeholder="Nombre"
              v-model="name"
              v-validate="'required'"
              class="mt-5"
              name="name"
            />
            <span class="text-danger text-sm" v-show="errors.has('name')">{{
              errors.first("name")
            }}</span>
            <vs-input
              label="Nueva contraseña"
              type="password"
              placeholder=""
              v-model="password"
              name="password"
              ref="password"
            />
            <vs-input
              label="Repite contraseña"
              type="password"
              placeholder=""
              v-validate="'confirmed:password'"
              data-vv-as="password"
              v-model="password2"
              name="password2"
            />
            <span
              class="text-danger text-sm"
              v-show="errors.has('password2')"
              >{{ errors.first("password2") }}</span
            >
            <vs-input
              label="Teléfono"
              placeholder=""
              v-model="telefono"
              type="number"
              class="mt-5"
              name="telefono"
            />
            <vs-alert
              v-if="telefono == '' || telefono === null"
              color="warning"
              style=""
            >
              Necesitamos tu teléfono para contactar contigo si hay alguna
              incidencia. Si lo crees conveniente, incluye en el
              <a
                style="cursor: pointer"
                @click="$router.push({ path: 'hijos' })"
                >perfil de cada persona</a
              >
              su teléfono para contactarle en caso necesario.
            </vs-alert>
            <br />
            <vs-checkbox v-model="abonado"
              >Soy abonado de Stadium Casablanca</vs-checkbox
            >
            <vs-checkbox v-model="masinfo" v-show="!abonado"
              >Quiero recibir información sobre actividades de Stadium
              Casablanca</vs-checkbox
            >
            <br />
            <vs-alert
              v-if="merchant_identifier != '' && merchant_identifier !== null"
              color="warning"
              style="margin-bottom: 20px; min-height: 100px"
            >
              Datos de la tarjeta de crédito guardados. Puedes eliminar la
              referencia pulsando aquí:
              <vs-button
                @click.prevent="eliminar_datos_paygold"
                color="warning"
                type="filled"
                style="margin-top: 20px"
                >Eliminar datos</vs-button
              >
            </vs-alert>
          </vs-col>
          <vs-col vs-w="6" style="margin-top: 18px">
            <vs-input
              :danger="errors.has('form.nif')"
              :danger-text="errors.first('form.nif')"
              label="NIF/NIE"
              type="nif"
              v-validate="'min:9|max:9'"
              data-vv-as="nif"
              v-model="nif"
              name="nif"
              ref="nif"
              v-mask="['X#######A', 'A#######A']"
              :class="{ input: true, 'is-danger': errors.has('form.nif') }"
              style="min-width: 230px"
              v-on:keyup="upper()"
            />
          </vs-col>
        </vs-row>
        <vs-row>
          <vs-button @click.prevent="save_user" color="primary" type="filled"
            >Guardar</vs-button
          >
        </vs-row>
      </vx-card>
    </form>
  </div>
</template>

<script>
//import JQuery from 'jquery'
//let $ = JQuery
/*
import { ValidationProvider, extend } from 'vee-validate';
extend('required', {
  message: 'Este campo es necesario'
});
*/

import vSelect from "vue-select";

export default {
  data() {
    return {
      user_id: 0,
      name: "",
      password: "",
      password2: "",
      abonado: false,
      telefono: "",
      masinfo: false,
      nif: "",
      merchant_identifier: "",
      paygold_expiry_date: "",
    };
  },
  computed: {
    nif_validation(ele) {
      if (ele.nif.lenght !== 9) return ["El NIF/NIE debe tener 9 cifras"];
      return [];
    },

    errors() {
      var errores = [];
      this.errors.items.foreach((error) => {
        error;
      });
      return errores;
    },
  },
  mounted() {
    //Primero de todo obtenemos los hijos que tenga este gacho.
    this.get_user();
  },
  methods: {
    upper() {
      this.nif = this.nif.toUpperCase();
    },
    async get_user() {
      this.$vs.loading({
        type: "default",
      });
      await this.$store.dispatch("get_user").then((data) => {
        if (typeof data !== "undefined") {
          this.user_id = data.id;
          this.name = data.name;
          this.abonado = data.abonado;
          this.telefono = data.telefono;
          this.masinfo = data.masinfo;
          this.nif = data.nif;
          this.merchant_identifier = data.merchant_identifier;
          this.paygold_expiry_date = data.paygold_expiry_date;
        }
      });
      this.$vs.loading.close();
    },
    eliminar_datos_paygold() {
      this.merchant_identifier = null;
      this.paygold_expiry_date = null;
      this.save_user();
    },
    save_user() {
      this.$validator.validateAll("form").then((result) => {
        if (result) {
          this.$store
            .dispatch("save_user", {
              id: this.user_id,
              name: this.name,
              password: this.password,
              password2: this.password2,
              abonado: this.abonado,
              telefono: this.telefono,
              masinfo: this.masinfo,
              nif: this.nif,
              merchant_identifier: this.merchant_identifier,
              paygold_expiry_date: this.paygold_expiry_date,
            })
            .then((message) => {
              this.$vs.notify({
                title: "Éxito",
                text: message,
                iconPack: "feather",
                icon: "icon-thumbs-up",
                color: "success",
              });
              //this.$store.dispatch()
            })
            .catch((message) => {
              this.$vs.notify({
                title: "Error",
                text: message,
                iconPack: "feather",
                icon: "icon-alert-circle",
                color: "danger",
              });
            });
        } else {
          this.$vs.notify({
            title: "Error",
            text: "Corrige los errores",
            iconPack: "feather",
            icon: "icon-alert-circle",
            color: "danger",
          });
        }
      });
    },
  },
  components: {
    "v-select": vSelect,
    //ValidationProvider
  },
};
</script>
